type FileSizeUnits
  = | 'B'
    | 'KB'
    | 'MB'
    | 'GB'
    | 'TB'
    | 'PB'
    | 'EB'
    | 'ZB'
    | 'YB';

export function prettyPrintFileSize(sizeStr: string | number): string {
  const size = BigInt(sizeStr);
  const units: FileSizeUnits[] = [
    'B',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB',
    'EB',
    'ZB',
    'YB',
  ];

  if (size === BigInt(0)) {
    return '0 B';
  }

  const magnitude = Math.min(
    Math.floor(Math.log2(Number(size)) / 10),
    units.length - 1,
  );
  const divisor = BigInt(1024) ** BigInt(magnitude);
  const wholePart = size / divisor;
  const fractionPart = size % divisor;

  // If there's no fractional part, return the whole part directly.
  if (fractionPart === BigInt(0)) {
    return `${wholePart} ${units[magnitude]}`;
  }

  // Convert the fractional part to a decimal fraction.
  const fractionStr = (Number(fractionPart) / Number(divisor))
    .toFixed(1)
    .substr(1);

  return `${wholePart}${fractionStr} ${units[magnitude]}`;
}

export function isImage(mimeType: string): boolean {
  return mimeType.startsWith('image');
}

export function isVideo(mimeType: string): boolean {
  return mimeType.startsWith('video');
}

export function isPdf(mimeType: string): boolean {
  return mimeType.startsWith('application/pdf');
}
